import { useCurrentLocale } from '@locales/client';
import { useMemo } from 'react';

export const useLocaleFormat = () => {
  const currentLocale = useCurrentLocale();

  const formatUrl = useMemo(() => {
    return (url = '') => {
      if (!url) return currentLocale;
      const normalizedUrl = url.startsWith('/') ? url.slice(1) : url;

      return normalizedUrl
        ? `/${currentLocale}/${normalizedUrl}`
        : `/${currentLocale}`;
    };
  }, [currentLocale]);

  return formatUrl;
};
